module.exports = __webpack_public_path__ + "static/media/video.ba7c0f64.mp4";